module.exports = __webpack_public_path__ + "img/feb-month.f6c27376.png";